module.exports = __webpack_public_path__ + "static/media/peanuts.bd2035f2.svg";